import React from "react";
import { Link } from "react-router-dom";
import { Minus, Plus, Trash2, ArrowRight } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function AppCart() {
  const { items, removeFromCart, updateQty, subtotal } = useCart();

  return (
    <div data-testid="app-cart" className="pb-32">
      <header className="px-5 pt-12 pb-3">
        <div className="text-[11px] tracking-luxury uppercase text-poche-gold">Bag</div>
        <h1 className="font-serif text-2xl mt-1">{items.length} pieces</h1>
      </header>
      {items.length === 0 ? (
        <div className="px-5 text-center mt-10 text-white/55 text-sm">
          Your bag is empty.<br />
          <Link to="/app/shop" className="text-poche-gold underline underline-offset-4">Enter the collection →</Link>
        </div>
      ) : (
        <>
          <div className="divide-y divide-white/10 border-t border-b border-white/10">
            {items.map((i) => (
              <div key={i.product_id} className="flex gap-3 px-5 py-4">
                <div className="bg-poche-ivory w-20 h-20 flex-shrink-0 overflow-hidden">
                  <img src={i.image} alt="" className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] tracking-luxury uppercase text-white/55">{i.name}</div>
                  <div className="font-serif">{i.subtitle}</div>
                  <div className="text-poche-gold text-sm">${(i.price * i.qty).toLocaleString()}</div>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center border border-white/15">
                      <button onClick={() => updateQty(i.product_id, i.qty - 1)} className="p-1.5"><Minus size={12} /></button>
                      <span className="px-3 text-xs">{i.qty}</span>
                      <button onClick={() => updateQty(i.product_id, i.qty + 1)} className="p-1.5"><Plus size={12} /></button>
                    </div>
                    <button onClick={() => removeFromCart(i.product_id)}><Trash2 size={14} className="text-white/55" /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="px-5 mt-5 space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-white/65">Subtotal</span><span>${subtotal.toLocaleString()}</span></div>
            <div className="flex justify-between"><span className="text-white/65">Shipping</span><span>Complimentary</span></div>
            <div className="flex justify-between font-serif text-xl pt-3 border-t border-white/10 mt-3"><span>Total</span><span className="text-poche-gold">${subtotal.toLocaleString()}</span></div>
          </div>
          <Link to="/checkout" data-testid="app-checkout" className="btn-gold w-full justify-center mt-6 mx-5" style={{ width: "calc(100% - 2.5rem)" }}>
            Checkout <ArrowRight size={14} />
          </Link>
        </>
      )}
    </div>
  );
}
